import React from 'react';
import { Col, Collapse, Row } from 'antd';
import { Field } from 'redux-form';
import { SelectField, TextAreaField, NumberField } from 'redux-form-antd';
import { CheckboxField } from '../../../services/ant-redux';

// Click Actions.
const clickActions = [
  { label: 'Browser', value: 'browser' },
  { label: 'Browser Close', value: 'browser_close' },
  { label: 'Deeplink', value: 'deeplink' },
  { label: 'Modal', value: 'modal' },
];

const OptionalFields = ({ formItemLayout, namePrefix, showAdPush }) => (
  <Collapse bordered={false} style={{ marginBottom: 20 }}>
    <Collapse.Panel header="Optional" key="1">
      <Row>
        <Col>
          <Field
            {...formItemLayout}
            label="Width"
            name={namePrefix ? namePrefix.replace('REPLACE_THIS', 'width') : 'width'}
            type="text"
            parse={a => a && !isNaN(Number(a)) && Number(a)}
            component={NumberField}
            placeholder={320}
          />
        </Col>
        <Col>
          <Field
            {...formItemLayout}
            label="Height"
            name={namePrefix ? namePrefix.replace('REPLACE_THIS', 'height') : 'height'}
            type="text"
            parse={a => a && !isNaN(Number(a)) && Number(a)}
            component={NumberField}
            placeholder={503}
          />
        </Col>
      </Row>

      <Row />

      <Row>
        <Col>
          <Field
            {...formItemLayout}
            label="Click Action"
            name={namePrefix ? namePrefix.replace('REPLACE_THIS', 'click_action') : 'click_action'}
            component={SelectField}
            options={clickActions}
          />
        </Col>

        <Col>
          <Field
            {...formItemLayout}
            label="Scrollable Creative"
            name={namePrefix ? namePrefix.replace('REPLACE_THIS', 'scrollable') : 'scrollable'}
            parse={a => !!a}
            component={CheckboxField}
          />
        </Col>
      </Row>

      {showAdPush && (
        <Row>
          <Col span={11}>
            <Field
              {...formItemLayout}
              extra="Ad Messages only display on inMarket Apps"
              label="Ad Push Message"
              validateStatus="validating"
              name={
                namePrefix
                  ? namePrefix.replace('REPLACE_THIS', 'ad_push_message')
                  : 'ad_push_message'
              }
              component={TextAreaField}
            />
          </Col>
        </Row>
      )}
    </Collapse.Panel>
  </Collapse>
);

OptionalFields.defaultProps = {
  showAdPush: false,
  namePrefix: false,
  formItemLayout: {
    colon: false,
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  },
};

export default OptionalFields;
